import React, { ButtonHTMLAttributes, FC } from 'react';
import { SwitchSizes } from '../Types';
import styles from './Switch.module.scss';
interface SwitchPropTypes extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: SwitchSizes;
  className?: string;
}
const Switch: FC<SwitchPropTypes> = ({
  checked,
  onChange,
  disabled,
  size = 'medium',
  className = '',
  ...props
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled) {
      onChange(!checked);
    }
  };
  return <button type="button" {...props} className={styles['switch-class'] + ' ' + styles[size] + ' ' + `${checked ? styles['checked'] : ''}` + ' ' + `${disabled ? styles['disabled'] : ''}` + ' ' + className} onClick={handleClick} disabled={disabled} data-sentry-component="Switch" data-sentry-source-file="Switch.tsx">
      <span className={styles['slider']} />
    </button>;
};
export default Switch;